<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      <el-breadcrumb-item>文章管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入标题"
            v-model="queryInfo.Title"
            clearable
            @clear="getArticleList(1)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getArticleList(1)"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="show()">发布</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="Title" label="标题">
        </el-table-column>
        <el-table-column prop="ColumnName" label="栏目" width="200"> </el-table-column>
        <el-table-column
          prop="ReleaseTime"
          label="更新时间"
          :formatter="dataFormat"
          width="200"
        >
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="edit(scope.row)"
              >修改</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteCreate(scope.row.ArticleManagementID)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[1, 2, 5, 10]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        v-if="total != 0"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        Title: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0
    }
  },
  created() {
    //   默认获取列表
    // console.log(this.queryInfo.pagenum)
    // this.getArticleList(this.queryInfo.pagenum)
  },
  mounted() {
    // 修改页返回页码赋值
    this.gettopagenum()
  },
  destroyed() {
    // 销毁缓存
    localStorage.removeItem('detail')
  },
  methods: {
    //   获取列表
    async getArticleList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/ArticleManagement/GetArticleManagements',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.articleManagements
      this.total = res.Data.total
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getArticleList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      // 缓存当前页码
      window.localStorage.setItem('pagenum', newPage)
      this.getArticleList(newPage)
    },

    // 从修改页面返回列表获取页码重新赋值
    gettopagenum() {
      if (localStorage.getItem('detail')) {
        this.queryInfo.pagenum = Number(localStorage.getItem('pagenum'))
        this.getArticleList(this.queryInfo.pagenum)
      } else {
        this.queryInfo.pagenum = 1
        this.getArticleList(this.queryInfo.pagenum)
        // 从其它页面进列表页，清页码数据
        localStorage.removeItem('pagenum')
      }
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/ArticleManagement/DelArticleManagement?ArticleManagementID=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error(res.Msg)
      this.$message.success('删除成功')
      // 刷新列表
      this.getArticleList(1)
    },
    show() {
      this.$router.push('show')
    },
    edit(row) {
      // 存当前行数据
      window.localStorage.setItem('article', JSON.stringify(row))
      this.$router.push('edit')
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less" scoped>
.el-date-editor.el-input {
  width: 100% !important;
}
</style>
